import {
  BankSlipPay2B,
  Bolepix,
  CreditCardPay2B,
  DirectDebitPay2B,
  PixOpenFinancePay2B,
  PixPay2B,
} from "src/assets/mapfre-icons-components";
import ApiPaymentMethods from "./apiPaymentMethods";
import RoutesPath from "./RoutesPath";
import { CONSTANTS_STRINGS } from "./strings";

export const ApiHeaderKeys = {
  ACCEPT_KEY: "accept",
  ACCEPT_VALUE: "application/json, text/plain, */*",
  CONTENT_TYPE_KEY: "Content-Type",
  CONTENT_TYPE_VALUE: "application/json",
};

export const PaymentMethodKeys = {
  [ApiPaymentMethods.CREDIT_CARD]: {
    type: ApiPaymentMethods.CREDIT_CARD,
    icon: CreditCardPay2B,
    label: CONSTANTS_STRINGS.PAYMENT_METHOD_CREDIT_CARD,
    description: CONSTANTS_STRINGS.EMPTY,
    route: RoutesPath.CREDIT_CARD,
  },
  [ApiPaymentMethods.PIX]: {
    type: ApiPaymentMethods.PIX,
    icon: PixPay2B,
    label: CONSTANTS_STRINGS.PAYMENT_METHOD_PIX,
    description: CONSTANTS_STRINGS.EMPTY,
    route: RoutesPath.PIX,
  },
  [ApiPaymentMethods.BANK_SLIP]: {
    type: ApiPaymentMethods.BANK_SLIP,
    icon: BankSlipPay2B,
    label: CONSTANTS_STRINGS.PAYMENT_METHOD_BANK_SLIP,
    description: CONSTANTS_STRINGS.EMPTY,
    route: RoutesPath.BANK_SLIP,
  },
  [ApiPaymentMethods.OPEN_FINANCE]: {
    type: ApiPaymentMethods.OPEN_FINANCE,
    icon: PixOpenFinancePay2B,
    label: CONSTANTS_STRINGS.PAYMENT_METHOD_OPEN_FINANCE,
    description: CONSTANTS_STRINGS.EMPTY,
    route: RoutesPath.OPEN_FINANCE,
  },
  [ApiPaymentMethods.DIRECT_DEBIT]: {
    type: ApiPaymentMethods.DIRECT_DEBIT,
    icon: DirectDebitPay2B,
    label: CONSTANTS_STRINGS.PAYMENT_METHOD_DIRECT_DEBIT,
    description: CONSTANTS_STRINGS.EMPTY,
    route: RoutesPath.DIRECT_DEBIT,
  },
  [ApiPaymentMethods.BOLEPIX]: {
    type: ApiPaymentMethods.BOLEPIX,
    icon: Bolepix,
    label: CONSTANTS_STRINGS.PAYMENT_METHOD_BOLEPIX,
    description: CONSTANTS_STRINGS.EMPTY,
    route: RoutesPath.BOLEPIX,
  },
};

export const CreditCardKeys = {
  CARD_NUMBER: "cardNumber",
  HOLDER: "nameOnCard",
  EXPIRATION_DATE: "expirationDate",
  SECURITY_CODE: "cardKey",
  DOCUMENT: "document",
  DATE_OF_BIRTH: "dateOfBirth",
  INSTALLMENTS: "installments",
  BILLING_DAY: "billingDay",
  CREDIT_LIMIT_OPTION: "creditLimitOption",
};
